import { FEAT_CHANNEL_ANDROID, FEAT_CHANNEL_IOS, FEAT_CHANNEL_WEB } from '../constants';
export var DeliveryChannel = /*#__PURE__*/function (DeliveryChannel) {
  DeliveryChannel["WEB"] = "WEB";
  DeliveryChannel["NATIVE_IOS"] = "NATIVE_IOS";
  DeliveryChannel["NATIVE_ANDROID"] = "NATIVE_ANDROID";
  return DeliveryChannel;
}({});

// tslint:disable-next-line:no-namespace
(function (_DeliveryChannel) {
  function getKeys() {
    return Object.keys(DeliveryChannel).filter(function (ch) {
      return typeof DeliveryChannel[ch] === 'string';
    });
  }
  _DeliveryChannel.getKeys = getKeys;
  function getAllChannels() {
    var channels = DeliveryChannel.getKeys().map(function (key) {
      return DeliveryChannel[key];
    });
    channels.sort();
    return channels;
  }
  _DeliveryChannel.getAllChannels = getAllChannels;
  function fromString(str) {
    var value = str.trim().toUpperCase();
    switch (value) {
      case DeliveryChannel.WEB:
        return DeliveryChannel.WEB;
      case DeliveryChannel.NATIVE_IOS:
        return DeliveryChannel.NATIVE_IOS;
      case DeliveryChannel.NATIVE_ANDROID:
        return DeliveryChannel.NATIVE_ANDROID;
      default:
        return;
    }
  }
  _DeliveryChannel.fromString = fromString;
  function getLongName(channel) {
    switch (channel) {
      case DeliveryChannel.WEB:
        return 'Web';
      case DeliveryChannel.NATIVE_ANDROID:
        return 'Native Android';
      case DeliveryChannel.NATIVE_IOS:
        return 'Native Apple';
    }
  }
  _DeliveryChannel.getLongName = getLongName;
  function getShortName(channel) {
    switch (channel) {
      case DeliveryChannel.WEB:
        return 'Web';
      case DeliveryChannel.NATIVE_ANDROID:
        return 'Android';
      case DeliveryChannel.NATIVE_IOS:
        return 'Apple';
    }
  }
  _DeliveryChannel.getShortName = getShortName;
  function getAssociatedFlag(channel) {
    switch (channel) {
      case DeliveryChannel.WEB:
        return FEAT_CHANNEL_WEB;
      case DeliveryChannel.NATIVE_IOS:
        return FEAT_CHANNEL_IOS;
      case DeliveryChannel.NATIVE_ANDROID:
        return FEAT_CHANNEL_ANDROID;
    }
  }
  _DeliveryChannel.getAssociatedFlag = getAssociatedFlag;
  function fromAssociatedFlag(flag) {
    var value = flag.trim().toUpperCase();
    switch (value) {
      case FEAT_CHANNEL_WEB:
        return DeliveryChannel.WEB;
      case FEAT_CHANNEL_IOS:
        return DeliveryChannel.NATIVE_IOS;
      case FEAT_CHANNEL_ANDROID:
        return DeliveryChannel.NATIVE_ANDROID;
      default:
        return;
    }
  }
  _DeliveryChannel.fromAssociatedFlag = fromAssociatedFlag;
})(DeliveryChannel || (DeliveryChannel = {}));